import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  Filler, Title, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FormControlLabel, Checkbox, Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement,
  Filler, Title, Tooltip, Legend, ChartDataLabels,
);

const allLabels = ['Hasta 4 MDP', 'Más de 4 MDP y hasta 100 MDP', 'Más de 100 MDP y hasta 250 MDP', 'Más de 250 MDP y hasta 1,000 MDP', 'Más de 1,000 MDP y hasta 10,000 MDP', 'Más de 10,000 MDP'];

// Datos de las industrias para 2023
const dataIndustries2023 = {
  'Alimentos': [25, 0, 13, 25, 0 , 38],
};

// Datos de las industrias para 2024


const options = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 20,
      bottom: 30, // Más espacio abajo
      left: 20,
      right: 20,
    },
  },
  plugins: {
    legend: {
      position: 'top',
      labels: {
        font: { size: 14, weight: 'bold' },
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => `${context.dataset.label}: ${context.raw}%`,
      },
    },
    datalabels: {
      color: '#000',
      font: { weight: 'bold', size: 8 }, // Reducir tamaño de las etiquetas
      formatter: (value) => `${Math.round(value)}%`,
      anchor: 'end',
      align: 'top',
      offset: -5,
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: 'Categoría de Facturación Anual',
        font: { size: 12 },
      },
      ticks: {
        font: { size: 10 },
        maxRotation: 45, // Rotar etiquetas para evitar solapamiento
        minRotation: 0,
      },
    },
    y: {
      title: {
        display: true,
        text: 'Porcentaje (%)',
        font: { size: 12},
      },
      beginAtZero: true,
      max: 100,
      ticks: { stepSize: 10, font: { size: 10 } },
    },
  },
};

const HuellaFacturacion = ({ selectedCategories = allLabels }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const industriesToUse = Object.keys(dataIndustries2023);

  const filteredLabels = selectedCategories.length > 0
    ? allLabels.filter((label) => selectedCategories.includes(label))
    : allLabels;

    const selectedData2023 = industriesToUse
    .map((industry) => dataIndustries2023[industry])
    .filter((data) => Array.isArray(data));
  
  console.log(industriesToUse)

  const calculateAverageData = (dataArray) => {
    return filteredLabels.map((_, index) => {
      const values = dataArray.map((data) => data[allLabels.indexOf(filteredLabels[index])]);
      const numericValues = values.filter((value) => typeof value === 'number');
      const sum = numericValues.reduce((acc, curr) => acc + curr, 0);
      const avg = numericValues.length > 0 ? sum / numericValues.length : 0;
      return parseFloat(avg.toFixed(2));
    });
  };

  const averageData2023 = calculateAverageData(selectedData2023);

  const chartData = {
    labels: filteredLabels,
    datasets: [
      {
        label: '2023',
        data: averageData2023,
        backgroundColor: 'rgba(31, 61, 88, 0.2)',
        borderColor: 'rgba(31, 61, 88, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(31, 61, 88, 1)',
        pointBorderColor: '#fff',
        pointRadius: 3, // Reducir tamaño de puntos
        fill: 'start',
        tension: 0.4, // Suavizar línea
      },
    ],
  };


  const infoContent = {
    Analisis: 'Esto sugiere que las empresas de mayor escala están más avanzadas en temas de sostenibilidad y gestión ambiental, mientras que las de menor facturación aún tienen oportunidades de desarrollo en esta área. Destaca que la práctica está más presente en organizaciones con mayores niveles de ingresos, particularmente aquellas que facturan más de 10,000 millones de pesos, con una participación del 38%.',
    formula: 'Promedio de Facturación = Total Facturación por Categoría / Total de Industrias',
    description: 'La gráfica muestra el nivel de adopción de la medición de huella de carbono logística según el tamaño de facturación anual de las empresas. ',
  };

  return (
    <div style={{ width: '100%', height: '555px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Line data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HuellaFacturacion;